import {
  FETCH_BLOG_POSTS,
  FETCH_BLOG_POSTS_SUCCESS,
  FETCH_BLOG_POSTS_FAILED,

  FETCH_PUBLIC_BLOG_POSTS,
  FETCH_PUBLIC_BLOG_POSTS_SUCCESS,
  FETCH_PUBLIC_BLOG_POSTS_FAILED,
} from './constants';
import db from '../../firebaseAPI';



export function requestBlogPosts() {
  return {
    type: FETCH_BLOG_POSTS,
    payload: {},
  };
}


export function loadedBlogPosts(posts) {
  // LocalStorage.setItem('token', response.header['x-session-id']);

  return {
    type: FETCH_BLOG_POSTS_SUCCESS,
    payload: {
      data: posts,
    },
  };
}

export function failedBlogPosts(key, payload) {
  return {
    type: FETCH_BLOG_POSTS_FAILED,
    payload: {
      isFetching: true,
      key,
      data: { ...payload },
    },
  };
}

function fetchBlogPosts() {
  return (dispatch) => {
    dispatch(requestBlogPosts());
    return db
      .collection('posts')
      .onSnapshot(function (querySnapshot) {
        const posts = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        dispatch(loadedBlogPosts(posts));
      }, function (error) {
        dispatch(failedBlogPosts(error));
      });
  };
}

export default fetchBlogPosts;



// fetch public posts



export function requestPublicBlogPosts() {
  return {
    type: FETCH_PUBLIC_BLOG_POSTS,
    payload: {},
  };
}


export function loadedPublicBlogPosts(posts) {
  // LocalStorage.setItem('token', response.header['x-session-id']);

  return {
    type: FETCH_PUBLIC_BLOG_POSTS_SUCCESS,
    payload: {
      data: posts,
    },
  };
}

export function failedPublicBlogPosts(key, payload) {
  return {
    type: FETCH_PUBLIC_BLOG_POSTS_FAILED,
    payload: {
      isFetching: true,
      key,
      data: { ...payload },
    },
  };
}

export function fetchPublicBlogPosts() {
  return (dispatch) => {
    dispatch(requestPublicBlogPosts());
    return db
      .collection('posts')
      .where('isPublished', '==', true)
      .orderBy('createTime', 'desc')
      .get()
      .then(function (querySnapshot) {
        const posts = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        dispatch(loadedPublicBlogPosts(posts));
      })
      .catch(function (error) {
        dispatch(failedPublicBlogPosts(error));
      });
  };
}




// WEBPACK FOOTER //
// ./src/modules/blog/actions.js